// extracted by mini-css-extract-plugin
export var container = "_6f-0";
export var error = "_6f-9";
export var label = "_6f-5";
export var light = "_6f-6";
export var md = "_6f-3";
export var sm = "_6f-2";
export var thin = "_6f-8";
export var thinBold = "_6f-7";
export var vertical = "_6f-4";
export var xs = "_6f-1";